import React, { useMemo } from 'react';

import { tertiary600, gray100 } from 'components/new_ui/Colors';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext } from 'components/Managers/Dashboard/Context';
import useCoachRating from 'components/Managers/Dashboard/Hooks/useCoachRating';

export default function CoachFeedback() {
  const { state: { filters } } = useContext();
  const { data: coachRating, loading } = useCoachRating(filters);

  const rate = useMemo(() => coachRating * 20, [coachRating]);

  return (
    <>
      <h5 className="mb-4">Coach Feedback</h5>

      {loading ? <LoadingPlaceholder className="mb-3" /> : (
        <>
          <div className="dashboard-rating progress bg-white">
            <div
              className="progress-bar w-100"
              role="progressbar"
              style={{ background: `linear-gradient(90deg, ${tertiary600} ${rate}%, ${gray100} 0%)` }}
              aria-label="Coach Feedback"
              aria-valuenow={rate}
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </div>

          <div className="mt-1 text-center">
            {coachRating}
            <span className="text-muted">/5</span>
          </div>
        </>
      )}
    </>
  );
}
